<template lang="pug">
  Modal(ref="dlg" title="Add User" closeable="true")
    .add-user-modal-body.ssp-form-horizontal
      .form-group
        label.ic-label User
        .ic-control()
          .text-center.loading(v-if="loading")
            i.fa.fa-spinner.fa-pulse.fa-spin
          UserSelect(v-model="user")
    div(slot="footer")
      button.btn.btn-default(@click="$refs.dlg.cancel()") Cancel
      button.btn.btn-primary.create-button(@click="save") Add
</template>

<script>
import miniToastr from 'mini-toastr'
import Security from '@/service/apis/Security'
import UserSelect from '@/components/ssp/UserSelect'
import Modal from '@/components/common/Modal'

export default {
  props: {
    groupId: {
      type: Number
    }
  },
  data: () => ({
    loading: false,
    user: null,
    organization: null
  }),
  methods: {
    save() {
      const req = {
        groupId: this.groupId,
        userId: this.user.value
      }
      Security.addUserToGroup(this.groupId, this.user.value, req)
        .then(() => {
          miniToastr.success('User added to group')
          this.$emit('success')
          this.$refs.dlg.close()
        })
    },
    open() {
      this.organization = 0
      this.loading = true
      this.$refs.dlg.open()
      Security.getOrganization()
        .then((resp) => {
          this.organization = resp.data.organization.id
          this.loading = false
        })
    }
  },
  components: {
    UserSelect,
    Modal
  }
}
</script>

<style lang="scss">
.add-user-modal-body {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/management/group/AddUserModal.vue